export default __webpack_public_path__ + "static/Group 1732-25783b351e810fb71da73520c156dcc7.png";